import {IconButton, intlShape, loginContainer, utils} from '@wallaby-ui/core';
import PropTypes from 'prop-types';
import * as React from 'react';
import {defineMessages, injectIntl} from 'react-intl';

import styles from './EditButton.less';

const I18N = defineMessages({
  EDIT_BUTTON: {
    id: 'autoLayout.wrapper.button.edit',
    defaultMessage: 'Edit',
    description: 'text for auto layout screen container edit button',
  },
});

const EditButton = ({intl, isEditing, onEdit, showEdit}) => (
  <div className={styles.dlEditButtonWrapper} data-name={'editButton'}>
    {showEdit ? (
      <IconButton
        className={[styles.dlEditButtonWrapper, styles.dlScreenEditButton]}
        iconClass={isEditing ? 'far fa-edit' : 'fas fa-edit'}
        clickCallback={onEdit}
        titleText={utils.TranslateUtils.translate(I18N.EDIT_BUTTON, intl)}
      />
    ) : null}
  </div>
);

EditButton.displayName = 'EditButton';

EditButton.propTypes = {
  intl: intlShape.isRequired,
  isEditing: PropTypes.bool,
  onEdit: PropTypes.func,
  showEdit: PropTypes.bool,
};

EditButton.defaultProps = {
  isEditing: false,
  onEdit: undefined,
  showEdit: false,
};

export default injectIntl(EditButton);
